jQuery(document).ready(function($) {
  $('.intro-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, //5 seconds
    dots: true,
    arrows: true,
    nextArrow:
      '<button class="next"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    prevArrow:
      '<button class="prev"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    dotsClass: 'slider-dots',
    customPaging: function(slider, i) {
      //return '<button class="tab"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" class="svg-inline--fa fa-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path></svg></button>'
      return '<button class="tab"></button>'
    },
  })

  $('.featured-news__slider').slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  })

  $('.standard-gallery').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, //5 seconds
    dots: false,
    arrows: true,
    nextArrow:
      '<button class="next"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    prevArrow:
      '<button class="prev"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })

  $('.product-gallery').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, //5 seconds
    dots: false,
    arrows: true,
    nextArrow:
      '<button class="next"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    prevArrow:
      '<button class="prev"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })

  $('.case-study-gallery.gallery--slick').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, //5 seconds
    dots: false,
    arrows: true,
    nextArrow:
      '<button class="next"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    prevArrow:
      '<button class="prev"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })

  $('.post-gallery').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, //5 seconds
    dots: false,
    arrows: true,
    nextArrow:
      '<button class="next"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    prevArrow:
      '<button class="prev"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })

  // $('.gallery').slick({
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 5000, //5 seconds
  //   dots: false,
  //   arrows: true,
  //   nextArrow:
  //     '<button class="next"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
  //   prevArrow:
  //     '<button class="prev"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 2,
  //       },
  //     },
  //     {
  //       breakpoint: 640,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // })

  $('.testimonials-logo-gallery').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, //5 seconds
    dots: false,
    arrows: true,
    nextArrow:
      '<button class="next"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    prevArrow:
      '<button class="prev"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  })

  $('.team-members').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, //5 seconds
    dots: false,
    arrows: true,
    nextArrow:
      '<button class="next"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    prevArrow:
      '<button class="prev"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })

  $('.testimonials').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, //5 seconds
    dots: false,
    arrows: true,
    nextArrow:
      '<button class="next"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    prevArrow:
      '<button class="prev"><svg viewBox="0 0 18.4 41.8" xmlns="http://www.w3.org/2000/svg"><path d="m17.3.9-7.7 10-7.7 10 7.7 10 7.7 10" fill="none" stroke="#023565" stroke-miterlimit="10" stroke-width="3"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })

  // Image EQ Function
  function equaliseImageHeight() {
    // Grab all slides
    $('.image-height-eq .slick-slide').each(function() {
      // Loop over all slides
      // Get image inside slide
      const imgDiv = $(this).find('.image')
      // Check image width
      const imgWidth = imgDiv.width()
      const img = imgDiv.find('img')
      // set image height to equal image width
      img.height(imgWidth)
    })
  }
  // Event listener for slider resize event
  $('.image-height-eq').on('setPosition', equaliseImageHeight)
})
